/**
 * PC Dice Factory
 *
 * Creates color-specific PC dice components using a factory pattern.
 * All 4 color variants (Red, Blue, Yellow, Green) are generated from
 * PcDiceComponent with per-color schemes.
 */

import React from 'react';
import type { DiceProps } from '../basics/constants/types';
import PcDiceComponent from './PcDiceComponent';
import { PC_DICE_COLOR_SCHEMES, type PcDiceColorScheme } from './constants/diceColorSchemes';

type DiceColor = 'red' | 'blue' | 'yellow' | 'green';

function createPcDice(color: DiceColor) {
  const colorScheme: PcDiceColorScheme = PC_DICE_COLOR_SCHEMES[color];
  const displayName = `Pc${color.charAt(0).toUpperCase() + color.slice(1)}Dice`;

  const ColoredDice = React.memo(function ColoredDice(props: DiceProps) {
    return <PcDiceComponent {...props} colorScheme={colorScheme} />;
  });

  ColoredDice.displayName = displayName;
  return ColoredDice;
}

export const RedDice = createPcDice('red');
export const BlueDice = createPcDice('blue');
export const YellowDice = createPcDice('yellow');
export const GreenDice = createPcDice('green');
